export interface LanguageOptions {
  prefix?: string;
}
